define((require) => {
    "use strict";

    const AbstractWidgetView = require("shared/ui/experience/widgets/AbstractWidgetView");

    /**
     * The view rendering an enhanced text widget.
     *
     * @class TextEnhancedWidgetView
     * @constructor
     *
     * @cfg {TextEnhancedWidgetModel} model The model of the text widget being rendered.
     */
    const TextEnhancedWidgetView = AbstractWidgetView.extend("TextWidget", {
        showView() {
            this.__super();
        }
    });

    return TextEnhancedWidgetView;
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/textEnhancedWidget/TextWidgetView.js